import i18nFactory, { i18nRaw as i18nRawFactory } from '@yandex-int/i18n';
import React from 'react';

import { WrappedTextValue } from '../../components/WrappedTextValue/WrappedTextValue';
import { mapStringToCurrencySymbol } from '../../mappers/common/common';
import { formatNumber } from '../../service/FormatHelpers/FormatHelpers';
import { phrases, retargetings, usersProfile, ValidationErrorData } from '../../typings/common';
import { CommonPriceEditorTextValues } from '../../typings/commonPriceEditorState';
import { CampaignsCalcTypeFilter } from '../../typings/domain';
import { CurrencyCode } from '../../typings/graphql-public-grid';
import { GridViewType } from '../../typings/grid';

import * as keyset from './CommonPriceEditorHelper.i18n';

const i18nRaw = i18nRawFactory(keyset);
const i18n = i18nFactory(keyset);

export interface CommonPriceEditorValidationParams {
    minGeneralPrice: number;
    maxGeneralPrice: number;
    currency: CurrencyCode;
}

export function validateCommonPriceValue(
    value: number,
    validationParams: CommonPriceEditorValidationParams
): ValidationErrorData[] {
    const errors = [];

    if (value === undefined || value < validationParams.minGeneralPrice) {
        errors.push({
            text: i18nRaw('single-rate-min-price', {
                minValue: React.createElement(WrappedTextValue, {}, formatNumber(validationParams.minGeneralPrice)),
                currency: mapStringToCurrencySymbol(validationParams.currency)
            })
        });
    } else if (value > validationParams.maxGeneralPrice) {
        errors.push({
            text: i18nRaw('single-rate-max-price', {
                maxValue: React.createElement(WrappedTextValue, {}, formatNumber(validationParams.maxGeneralPrice)),
                currency: mapStringToCurrencySymbol(validationParams.currency)
            })
        });
    }

    return errors;
}

export function getCommonPriceTextValues(
    view: GridViewType,
    selectedCount: number,
    campaignsCalcTypeFilter?: CampaignsCalcTypeFilter
): CommonPriceEditorTextValues {
    if (!campaignsCalcTypeFilter) {
        return {
            title: i18n('common-price-editor-title'),
            priceText: i18n('set-price')
        };
    }

    switch (view) {
        case phrases:
            return {
                title: i18n('common-price-editor-title-phrases'),
                hintTitle: i18n('selected-phrases', { count: selectedCount }),
                description: i18n('common-price-editor-description-phrases'),
                priceText: i18n('set-cpm-price')
            };
        case retargetings:
            return {
                title: i18n('common-price-editor-title-retargetings'),
                hintTitle: i18n('selected-retargetings', {
                    count: selectedCount
                }),
                description: i18n('common-price-editor-description-retargetings'),
                priceText: i18n('set-cpc-price')
            };
        case usersProfile:
            if (campaignsCalcTypeFilter === CampaignsCalcTypeFilter.CPM) {
                return {
                    title: i18n('common-price-editor-title-users-profile'),
                    hintTitle: i18n('selected-retargetings', {
                        count: selectedCount
                    }),
                    description: i18n('common-price-editor-description-users-profile'),
                    priceText: i18n('set-cpm-price')
                };
            } else {
                return {
                    title: i18n('common-price-editor-title-users-profile'),
                    hintTitle: i18n('selected-retargetings', {
                        count: selectedCount
                    }),
                    description: i18n('common-price-editor-description-retargetings'),
                    priceText: i18n('set-cpc-price')
                };
            }
        default:
            return {
                title: i18n('common-price-editor-title'),
                priceText: i18n('set-price')
            };
    }
}
